import httpHelper from "@/helpers/httpHelper";
import _ from "lodash"
// action types
export const UPDATE_USER_CONF = "updateUserConf";


export default {
    state: {
    },
    getters: {
    },
    actions: {
        /**
         * update user config
         * @param state
         * @param payload
         */
        [UPDATE_USER_CONF](state, payload) {
            let api=payload.api;
            delete payload.api;
            return new Promise((resolve, reject) => {
                httpHelper
                    .postData(api,payload)
                    .then((response) => {
                       
                         resolve(response)   
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
       

    },
    mutations: {
    }
};